import React, { useContext } from 'react';
import DrawerContext from '../DrawerContext/DrawerContext';
import styles from './DrawerFooter.module.scss';
function DrawerFooter(_ref, ref) {
  var children = _ref.children;
  var _useContext = useContext(DrawerContext),
    footerRef = _useContext.footerRef;
  return /*#__PURE__*/React.createElement("div", {
    ref: !!ref ? ref : footerRef,
    className: styles.footer
  }, children);
}
export default React.forwardRef(DrawerFooter);